import React, { useState } from "react";
import { Link } from "react-router-dom";
import blogImg1 from '../assets/blog-image-1.jpg'


const iconStyle = {
  backgroundColor: "rgb(4,180,228)",
  color: "white",
  width: "40px",
  height: "40px",
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  borderRadius: "50%",
  fontSize: "18px",
  textDecoration: "none"
};

const PrivacyBlog = () => {
  const [calendarDate, setCalendarDate] = useState(new Date());

  const currentMonth = calendarDate.toLocaleString("default", { month: "long" });
  const currentYear = calendarDate.getFullYear();

  const today = new Date();

  const getPrevMonth = () => {
    const prev = new Date(calendarDate.getFullYear(), calendarDate.getMonth() - 1, 1);
    setCalendarDate(prev);
  };

  const getNextMonth = () => {
    const next = new Date(calendarDate.getFullYear(), calendarDate.getMonth() + 1, 1);
    setCalendarDate(next);
  };

  const getPreviousMonthName = () => {
    const prev = new Date(calendarDate.getFullYear(), calendarDate.getMonth() - 1, 1);
    return prev.toLocaleString("default", { month: "long" });
  };

  const getNextMonthName = () => {
    const next = new Date(calendarDate.getFullYear(), calendarDate.getMonth() + 1, 1);
    return next.toLocaleString("default", { month: "long" });
  };

  const generateCalendar = () => {
    const firstDay = new Date(calendarDate.getFullYear(), calendarDate.getMonth(), 1).getDay();
    const totalDays = new Date(calendarDate.getFullYear(), calendarDate.getMonth() + 1, 0).getDate();

    const days = [];
    let dayCount = 1;

    for (let i = 0; i < 6; i++) {
      const week = [];
      for (let j = 0; j < 7; j++) {
        if ((i === 0 && j < (firstDay === 0 ? 6 : firstDay - 1)) || dayCount > totalDays) {
          week.push(<td key={j}></td>);
        } else {
          const isToday =
            calendarDate.getMonth() === today.getMonth() &&
            calendarDate.getFullYear() === today.getFullYear() &&
            dayCount === today.getDate();

          week.push(
            <td key={j} className={isToday ? "bg-primary text-white fw-bold" : ""}>
              {dayCount++}
            </td>
          );
        }
      }
      days.push(<tr key={i}>{week}</tr>);
      if (dayCount > totalDays) break;
    }
    return days;
  };

  return (
    <div className="container my-5 text-start">
      <div className="row justify-content-center">
        {/* Main Blog Content */}
       <div className="container my-5 text-start" style={{ maxWidth: "800px" }}>
      {/* Image */}
       <img
          src={blogImg1}
          alt="Blog"
          className="img-fluid mb-4"
          style={{ borderRadius: "5px", width: "100%" }}
        />
      


      {/* Blog Category and Tags */}
      <p className="text-uppercase fw-semibold" style={{ color: "#29aae3" }}>
        <span style={{ borderTop: "2px solid #29aae3", paddingTop: "5px", display: "inline-block" }}>
          Blog • Uncategorized
        </span>
      </p>

      {/* Title */}
      <h2 className="fw-bold mb-3" style={{ color: "#29aae3" }}>
        How a Learning Management System is Useful?
      </h2>

      {/* Date and Author */}
      <p className="text-muted mb-4" style={{ fontSize: "14px" }}>
        November 11, 2020 / <span className="text-dark fw-medium">By Admin</span>
      </p>

      {/* Short Description */}
      <p className="text-dark" style={{ lineHeight: "1.7" }}>
       LMS or Learning Management system is a software management system which is used to deliver educational
        courses and/or training programs to the customer base. <br/>It is a software which helps in creation, change,
        assigning, grading of programs which can help you easily organize the courses you plan to deliver to the
        students. For example, LMS...
      </p>

      {/* Social icons and button */}
      <div className="d-flex justify-content-between align-items-center mt-4">
        <div className="d-flex gap-2">
          {/* Facebook */}
          <a href="https://www.facebook.com/waralstechnology/" style={iconStyle}>
            <i className="bi bi-facebook"></i>
          </a>

          {/* X (Twitter) */}
          <a href="https://x.com/WaralsT" style={iconStyle}>
            <i className="bi bi-twitter-x"></i>
          </a>

          {/* LinkedIn */}
          <a href="https://www.linkedin.com/company/waralstechnology" style={iconStyle}>
            <i className="bi bi-linkedin"></i>
          </a>
        </div>
     <a href="https://blogs.warals.com/how-learning-management-system-is-useful/"><button className="btn border-primary  btn-outline-primary">
          Read More &nbsp; →
        </button></a> 
      </div>
    </div>

        {/* Sidebar - Calendar */}
        <div className="col-lg-4 col-md-12 mt-5 mt-lg-0">
          <div>
            <h5>Calendar</h5>
            <div className="border p-3 text-center">
              <strong>{currentMonth} {currentYear}</strong>
              <table className="table table-bordered mt-2 mb-0">
                <thead className="bg-info text-white">
                  <tr>
                    <th>M</th><th>T</th><th>W</th><th>T</th><th>F</th><th>S</th><th>S</th>
                  </tr>
                </thead>
                <tbody>{generateCalendar()}</tbody>
              </table>
              <div className="d-flex justify-content-between mt-2">
                <a
                  href="#"
                  className="text-decoration-none"
                  onClick={(e) => {
                    e.preventDefault();
                    getPrevMonth();
                  }}
                >
                  « {getPreviousMonthName()}
                </a>
                <a
                  href="#"
                  className="text-decoration-none"
                  onClick={(e) => {
                    e.preventDefault();
                    getNextMonth();
                  }}
                >
                  {getNextMonthName()} »
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <hr></hr>
    </div>
  );
};

export default PrivacyBlog;
